// ============================================================================
// JARVISTRAVEL - SAMPLE DATA NOTICE (JAR-424)
// The third member of the JAR-314 degradation family, for the case the other
// two don't cover: the screen has content, but it isn't the user's.
//
//   BackendUnavailableBanner — app-wide, "we can't reach the servers"
//   OfflineNotice            — inline, beside a paused action
//   SampleDataNotice         — inline, above data that is a stand-in
//
// Same amber state-accent vocabulary (transient, recoverable — never red,
// which this codebase reserves for genuine errors). Deliberately NOT a live
// region: the app-wide banner owns the screen-reader announcement for an
// outage, and a second one would double-speak it.
// ============================================================================

import { Layers } from 'lucide-react';

interface SampleDataNoticeProps {
  /**
   * Whether the surrounding content is stand-in data. Rendering is the caller's
   * signal to give, not this component's to infer — "am I showing real data?"
   * is answered differently per screen (an empty API list is a legitimate empty
   * state on one screen and a failure on another).
   */
  degraded: boolean;
  /** Surface-specific copy; the default suits any list of sample content. */
  message?: string;
  className?: string;
}

export function SampleDataNotice({
  degraded,
  message = 'Showing sample content while we can’t reach our servers. This isn’t your data.',
  className = '',
}: SampleDataNoticeProps) {
  if (!degraded) return null;

  return (
    <div className={`flex items-start gap-2 rounded-xl border border-warning/20 bg-warning/10 px-3 py-2.5 ${className}`}>
      <Layers className="w-4 h-4 mt-0.5 shrink-0 text-warning" strokeWidth={2} aria-hidden="true" />
      <p className="text-sm text-body leading-snug">{message}</p>
    </div>
  );
}

export default SampleDataNotice;
